export const userIndustries = [
    'agency',
    'app',
    'beauty',
    'clothing',
    'consumerGoods',
    'education',
    'electronics',
    'entertainment',
    'finance',
    'fitness',
    'foodBeverage',
    'games',
    'healthcare',
    'home',
    'kids',
    'news',
    'other',
    'pets',
    'politics',
    'realEstate',
    'services',
    'sportsOutdoor',
    'transport',
    'travel',
    'travelAccessories',
];
//# sourceMappingURL=index.js.map